 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"polyfills-core-js":"polyfills-core-js","polyfills-dom":"polyfills-dom","stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-02c995b5":"dd20b190","chunk-09155df3":"121025b2","chunk-09162720":"45a67412","chunk-097e0872":"c64bf7c1","chunk-0e93a01c":"47783e2d","chunk-106fab1a":"c4a68f24","chunk-1119adbc":"ad4feff3","chunk-11d07768":"b2494b13","chunk-15336eff":"6a25e793","chunk-10223bea":"c36a10d1","chunk-1bff95de":"9f2d840b","chunk-1c0e08ec":"87972605","chunk-0ae3f829":"06575b94","chunk-14cef8ee":"8c94e793","chunk-10870038":"ada3b70e","chunk-18a1ee3a":"98f2a9c1","chunk-502a2ce8":"0ac3da99","chunk-5ddc8ac0":"f67cf4c2","chunk-11176f6e":"ebacdd93","chunk-111ca256":"f9c385ed","chunk-1656cc2a":"a242e126","chunk-323bc5b8":"1983a82c","chunk-39292cf8":"733a5904","chunk-51849545":"94f9771e","chunk-6749cb8f":"c8a9c911","chunk-b4f1a000":"bb670ef5","chunk-9ff52a56":"acca0097","chunk-22c60b5e":"32e3192b","chunk-7da5b9f6":"c1d36edd","chunk-abdd8d3e":"585d1bf0","chunk-a86fc70a":"1471481d","chunk-d6e863a2":"d220c6e4","chunk-16afe9ce":"e0326496","chunk-98c1b212":"3514c9bc","chunk-1dbc15a2":"e9460232","chunk-21a76241":"6e53da2a","chunk-25d83ca8":"b5086644","chunk-2d0a463b":"6535b038","chunk-2d0ac931":"17cfa0f8","chunk-2d0c073f":"9cb05e0c","chunk-2d0c211b":"ba545cf5","chunk-2d0cf315":"1ef6206f","chunk-2d0d43da":"84a18a17","chunk-2d0da04a":"c960fda5","chunk-2d0e5812":"69d7012f","chunk-2d208e4e":"cae41b4f","chunk-2d213189":"2d0a3e5f","chunk-2d217def":"b35cd03e","chunk-2d217e6a":"21eb2a4b","chunk-2d218068":"a88b8818","chunk-2d21a9aa":"6003d65f","chunk-2d21da73":"b9907c55","chunk-2d222cca":"2219326e","chunk-2d22895d":"b81bc54f","chunk-2d2304d2":"f46cf096","chunk-2d23721e":"db20ec86","chunk-2d237b00":"0cff8677","chunk-30dd9750":"2be7ab59","chunk-37f2300e":"b64301e0","chunk-3ed29de3":"3438a73e","chunk-41c0f7a4":"fabd5ffe","chunk-462c869e":"31d18e40","chunk-47245a33":"76e78edd","chunk-4739acd0":"6b47b317","chunk-485adc83":"94f5fd82","chunk-53b1137a":"3784bede","chunk-541ea42d":"56c1e56a","chunk-54bbd082":"c87b4d43","chunk-59d4c87c":"2f0c9a00","chunk-5a8ac886":"7b77c1b3","chunk-5ff96a24":"acc845d4","chunk-69eb8776":"0eac85da","chunk-6d375f34":"0d632e47","chunk-6d7c3e5e":"5bab0f43","chunk-7548ca2d":"e61afe83","chunk-79f1dac7":"12825bd4","chunk-858cd918":"a55d1a47","chunk-8bb7f81e":"d40befe2","chunk-98e810bc":"d330be53","chunk-a9395c36":"b8a0318c","chunk-aa9d99b6":"dc293518","chunk-ab03931c":"3e19c4cc","chunk-c84a9124":"9093390c","chunk-d0e8aa0a":"62e32603","chunk-d8413eac":"a1b3c4b6","chunk-e2f2229e":"9564d27c","chunk-e5275ddc":"aa3ff33b","chunk-ea4e8458":"8db434c4","chunk-eaa2b130":"b460437c","chunk-fa0052a0":"e635c1cf","polyfills-core-js":"8da452c8","polyfills-dom":"5c1a31ff","stencil-polyfills-css-shim":"54fc0886","stencil-polyfills-dom":"a351dbf1","chunk-2d216786":"0efd2206","chunk-2d2297f7":"f0535631","chunk-2d2073d6":"7c708fa8","chunk-2d0b33e3":"64be60e2","chunk-2d0b9074":"235efaf0","chunk-2d0b9280":"acc735b6","chunk-2d0baac9":"cbb5edf0","chunk-2d2376e6":"a351546d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-1119adbc":1,"chunk-11d07768":1,"chunk-15336eff":1,"chunk-1c0e08ec":1,"chunk-0ae3f829":1,"chunk-14cef8ee":1,"chunk-10870038":1,"chunk-18a1ee3a":1,"chunk-502a2ce8":1,"chunk-5ddc8ac0":1,"chunk-11176f6e":1,"chunk-1656cc2a":1,"chunk-323bc5b8":1,"chunk-51849545":1,"chunk-6749cb8f":1,"chunk-9ff52a56":1,"chunk-22c60b5e":1,"chunk-7da5b9f6":1,"chunk-abdd8d3e":1,"chunk-a86fc70a":1,"chunk-d6e863a2":1,"chunk-16afe9ce":1,"chunk-98c1b212":1,"chunk-6d7c3e5e":1,"chunk-98e810bc":1,"chunk-aa9d99b6":1,"chunk-ab03931c":1,"chunk-c84a9124":1,"chunk-e2f2229e":1,"chunk-ea4e8458":1,"chunk-fa0052a0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"polyfills-core-js":"polyfills-core-js","polyfills-dom":"polyfills-dom","stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-02c995b5":"31d6cfe0","chunk-09155df3":"31d6cfe0","chunk-09162720":"31d6cfe0","chunk-097e0872":"31d6cfe0","chunk-0e93a01c":"31d6cfe0","chunk-106fab1a":"31d6cfe0","chunk-1119adbc":"9d5718f7","chunk-11d07768":"6b79987c","chunk-15336eff":"9600d0e5","chunk-10223bea":"31d6cfe0","chunk-1bff95de":"31d6cfe0","chunk-1c0e08ec":"6b79987c","chunk-0ae3f829":"35cfec5b","chunk-14cef8ee":"bcd0da52","chunk-10870038":"f3131ee9","chunk-18a1ee3a":"3ff97e02","chunk-502a2ce8":"3b0b0a9e","chunk-5ddc8ac0":"3ff97e02","chunk-11176f6e":"927d6c50","chunk-111ca256":"31d6cfe0","chunk-1656cc2a":"236602d9","chunk-323bc5b8":"927d6c50","chunk-39292cf8":"31d6cfe0","chunk-51849545":"927d6c50","chunk-6749cb8f":"927d6c50","chunk-b4f1a000":"31d6cfe0","chunk-9ff52a56":"8616f63e","chunk-22c60b5e":"f3ba9d07","chunk-7da5b9f6":"6d0bfb59","chunk-abdd8d3e":"8f4be725","chunk-a86fc70a":"0dc9ee3f","chunk-d6e863a2":"161e586e","chunk-16afe9ce":"6380009f","chunk-98c1b212":"292091a0","chunk-1dbc15a2":"31d6cfe0","chunk-21a76241":"31d6cfe0","chunk-25d83ca8":"31d6cfe0","chunk-2d0a463b":"31d6cfe0","chunk-2d0ac931":"31d6cfe0","chunk-2d0c073f":"31d6cfe0","chunk-2d0c211b":"31d6cfe0","chunk-2d0cf315":"31d6cfe0","chunk-2d0d43da":"31d6cfe0","chunk-2d0da04a":"31d6cfe0","chunk-2d0e5812":"31d6cfe0","chunk-2d208e4e":"31d6cfe0","chunk-2d213189":"31d6cfe0","chunk-2d217def":"31d6cfe0","chunk-2d217e6a":"31d6cfe0","chunk-2d218068":"31d6cfe0","chunk-2d21a9aa":"31d6cfe0","chunk-2d21da73":"31d6cfe0","chunk-2d222cca":"31d6cfe0","chunk-2d22895d":"31d6cfe0","chunk-2d2304d2":"31d6cfe0","chunk-2d23721e":"31d6cfe0","chunk-2d237b00":"31d6cfe0","chunk-30dd9750":"31d6cfe0","chunk-37f2300e":"31d6cfe0","chunk-3ed29de3":"31d6cfe0","chunk-41c0f7a4":"31d6cfe0","chunk-462c869e":"31d6cfe0","chunk-47245a33":"31d6cfe0","chunk-4739acd0":"31d6cfe0","chunk-485adc83":"31d6cfe0","chunk-53b1137a":"31d6cfe0","chunk-541ea42d":"31d6cfe0","chunk-54bbd082":"31d6cfe0","chunk-59d4c87c":"31d6cfe0","chunk-5a8ac886":"31d6cfe0","chunk-5ff96a24":"31d6cfe0","chunk-69eb8776":"31d6cfe0","chunk-6d375f34":"31d6cfe0","chunk-6d7c3e5e":"6b79987c","chunk-7548ca2d":"31d6cfe0","chunk-79f1dac7":"31d6cfe0","chunk-858cd918":"31d6cfe0","chunk-8bb7f81e":"31d6cfe0","chunk-98e810bc":"6b79987c","chunk-a9395c36":"31d6cfe0","chunk-aa9d99b6":"a48d6523","chunk-ab03931c":"6b79987c","chunk-c84a9124":"6b79987c","chunk-d0e8aa0a":"31d6cfe0","chunk-d8413eac":"31d6cfe0","chunk-e2f2229e":"925fc113","chunk-e5275ddc":"31d6cfe0","chunk-ea4e8458":"6b79987c","chunk-eaa2b130":"31d6cfe0","chunk-fa0052a0":"ffbe9b29","polyfills-core-js":"31d6cfe0","polyfills-dom":"31d6cfe0","stencil-polyfills-css-shim":"31d6cfe0","stencil-polyfills-dom":"31d6cfe0","chunk-2d216786":"31d6cfe0","chunk-2d2297f7":"31d6cfe0","chunk-2d2073d6":"31d6cfe0","chunk-2d0b33e3":"31d6cfe0","chunk-2d0b9074":"31d6cfe0","chunk-2d0b9280":"31d6cfe0","chunk-2d0baac9":"31d6cfe0","chunk-2d2376e6":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
